<template>
    <div class="menu-container">
        <el-menu class="el-menu-demo" mode="horizontal" :ellipsis="false" @select="handleSelect"
            background-color="#ffffff00">
            <el-menu-item class="my-logo menu-item my-img">
                <img src="../../public/img/logo.svg" alt="Element logo"
                    @click="() => { $router.push('/'); $store.commit('setMenuItemIndex', '') }" />
            </el-menu-item>
            <el-menu-item index="1" class="my-logo menu-item refpos"
                :style="($store.state.menuItemIndex == '1') ? styleActive : ''">Home</el-menu-item>
            <el-menu-item index="2" class="my-logo menu-item refpos"
                :style="($store.state.menuItemIndex == '2') ? styleActive : ''">Conferences</el-menu-item>
            <el-menu-item index="3" class="my-logo menu-item refpos"
                :style="($store.state.menuItemIndex == '3') ? styleActive : ''">Contact</el-menu-item>
            <el-menu-item index="4" class="my-logo menu-item refpos"
                :style="($store.state.menuItemIndex == '4') ? styleActive : ''">AboutUs</el-menu-item>
            <el-sub-menu index="5" class="my-logo menu-item refpos"
                :style="($store.state.menuItemIndex == '5') ? styleActive : ''">
                <template #title><span class="shun-box">ConfChair</span></template>
                <el-menu-item index="5-1" class="my-list-item">My recent roles</el-menu-item>
                <el-menu-item index="5-2" class="my-list-item">My conferences</el-menu-item>
                <el-menu-item index="5-3" class="my-list-item">Create new conference</el-menu-item>
            </el-sub-menu>
            <el-menu-item class="show-box refpos">
                <div class="btn-reg-box" v-if="!isLogin">
                    <el-button color="#626aef" size="small" @click="$router.push('/login')">Login</el-button>
                    <el-button type="primary" size="small" @click="$router.push('/login?isLogin=false')"
                        style="margin-left: 20px;">Register</el-button>
                </div>
                <div class="own" v-else>
                    <el-dropdown>
                        <div class="headinfo">
                            <el-badge :value="$store.state.unreadCount" :max="9" class="item"
                                v-if="$store.state.unreadCount > 0">
                                <el-avatar :src="$store.state.user.pic"></el-avatar>
                            </el-badge>
                            <el-avatar :src="$store.state.user.pic" v-else></el-avatar>
                            <div class="email-text">{{ $store.state.user.email }}</div>
                            <el-icon style="margin-left:5px">
                                <arrow-down />
                            </el-icon>
                        </div>
                        <template #dropdown>
                            <el-dropdown-menu style="width: 150px;">
                                <el-dropdown-item @click="$router.push('/common/message')">
                                    Message
                                </el-dropdown-item>
                                <el-dropdown-item @click="$router.push('/common/my')">HomePage</el-dropdown-item>
								<!-- <el-dropdown-item @click="signout">Signout</el-dropdown-item> -->
                                <el-dropdown-item @click="logout">Logout</el-dropdown-item>   

                                <el-dropdown-item @click="changeEmailPassword" v-if="store.state.user.isadmin"> ChangeEmailPassword </el-dropdown-item>                        
                            </el-dropdown-menu>
                        </template>
                    </el-dropdown>
                </div>
            </el-menu-item>
        </el-menu>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from "vue-router";
import { ArrowDown } from '@element-plus/icons-vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { ElNotification } from 'element-plus'
import request from "../network/request"

let store = useStore()
const router = useRouter();
const route = useRoute();
let isLogin = ref(false)
let styleActive = "border-bottom: 2px solid var(--el-menu-active-color);color:#409eff;"


onMounted(() => {
    // 判断用户是否登录
    isLogin.value = store.state.user.email ? true : false
})

// 退出登录
const logout = () => {
    request.post("/user/logout").then((res) => {
        if (res.code == 200) {
            ElNotification({
                title: ' logout succeeded',
                message: 'About to jump to the loginpage',
                type: 'success',
                duration: 2000
            });
            isLogin.value = false
            store.commit("resetState")
            localStorage.removeItem("conferenceStore")
            console.log("跳转");
            router.push("/login")
        }
    })
}

// 注销登录
const signout = () => {
    ElMessageBox.confirm(
        'To signout your account?we will clear all your information.Please consider carefully',
        'Account Signout',
        {
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancel',
            type: 'warning',
        }
    )
        .then(() => {
            request.post("/user/signout").then((res) => {
                if (res.code == 200) {
                    ElMessage({
                        type: 'success',
                        message: 'Signout successful',
                    })
                    isLogin.value = false
                    store.commit("resetState")
                    localStorage.removeItem("conferenceStore")
                    router.push("/login")
                }
            })
        })
        .catch(() => {
            ElMessage({
                type: 'info',
                message: 'Canceled',
            })
        })
}
const changeEmailPassword = () => {
    ElMessageBox.prompt('Please enter the new SMTP Authorization Code', 'Update Email Password', {
        confirmButtonText: 'Update',
        cancelButtonText: 'Cancel',
        inputPattern: /^[a-zA-Z0-9]{6,30}$/, // 简单的正则校验
        inputErrorMessage: 'Invalid Authorization Code',
    })
    .then(({ value }) => {
        // 1. 调用业务接口更新 Redis 中的密码
        // 注意：这里的 Key 必须对应后端 EmailConfig 中的 "confchair.spring.mail.password"
        request.post("/user/updateEmailConfig", { 
            password: value 
        }).then((res) => {
            if (res.code == 200) {

                ElMessage({
                    type: 'success',
                    message: 'Email Authorization Code updated successfully!',
                });
            } else {
                ElMessage.error(res.msg || 'Update failed');
            }
        });
    })
    .catch(() => {
        ElMessage({
            type: 'info',
            message: 'Update canceled',
        });
    });
};

// 切换路由
const handleSelect = (key, keyPath) => {
    // 路由跳转
    switch (key) {
        case "1":
            router.push("/")
            if (isLogin.value) store.commit("setMenuItemIndex", key)
            break;
        case "2":
            router.push("/common/myconferences")
            if (isLogin.value) store.commit("setMenuItemIndex", key)
            break;
        case "3":
            router.push("/common/contact")
            if (isLogin.value) store.commit("setMenuItemIndex", key)
            break;
        case "4":
            router.push("/common/aboutus")
            if (isLogin.value) store.commit("setMenuItemIndex", key)
            break;
        case "5-1":
            router.push("/common/role")
            if (isLogin.value) store.commit("setMenuItemIndex", keyPath[0])
            break;
        case "5-2":
            router.push("/common/myconferences")
            if (isLogin.value) store.commit("setMenuItemIndex", keyPath[0])
            break;
        case "5-3":
            router.push("/common/newconference")
            if (isLogin.value) store.commit("setMenuItemIndex", keyPath[0])
            break;
    }
}

</script>

<style lang="scss">
.menu-container {
    .el-menu--horizontal {
        --el-menu-hover-bg-color: rgba(240, 248, 255, 0) !important;
    }

    .el-menu-demo {
        padding-top: 20px;
        align-items: center;
        border-bottom: none;
        position: relative;
        border-bottom: none !important;

        .menu-item {
            margin-right: 10px;
            font-weight: 700;
            --el-menu-hover-bg-color: #ffffff00;
        }

        .el-sub-menu__title {
            // border-bottom: none !important;
            color: none !important;
        }

        .el-menu-item.is-active {
            border-bottom: none;
            color: none;
        }

        .show-box:hover {
            background-color: transparent;
            /* 或者使用已有的背景色 */
        }

        .my-list-item {
            font-size: 12px !important;
        }

        .show-box {
            flex: 1;
            display: flex;
            justify-content: right;

            .btn-reg-box {
                display: flex;
                align-items: center;
            }

            .own {
                position: absolute;
                right: 0px;
                display: flex;
                align-items: center;
                outline: none;

                .headinfo {
                    display: flex;
                    align-items: center;
                    outline: none;
                    cursor: pointer;

                    .email-text {
                        font-size: 13px;
                        margin-left: 10px;
                    }

                    .el-icon {
                        margin-top: 3px;
                    }
                }

                .el-avatar {
                    border: 1px solid #adc1edcf;
                    height: 42px;
                    width: 42px;
                }
            }

        }
    }

    .my-logo {
        justify-content: left !important;
        padding: 0 0 !important;
        margin-right: 60px !important;
        font-size: 14px !important;

        img {
            width: 145px;
            position: relative;
            top: 3px;
        }
    }

    .refpos {
        position: relative;
        top: 3px;
    }

    .my-img {
        margin-right: 100px !important;
    }

    .flex-grow {
        flex-grow: 1;
    }

    .shun-box {
        font-size: 14px;
    }
}
</style>